import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  DestinationsPicker,
  ServicesPicker,
  DurationsPicker,
} from "../widgets";
import _ from "lodash";
import { createUseStyles } from "react-jss";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import jssVariables from "../../../jss_setup";

const styles = createUseStyles({
  packageSearchForm: (props) => ({
    display: "grid",
    gridTemplateRows: "repeat(3, max-content)",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.packageSearchForm", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    packageSearchForm: (props) => ({
      gridTemplateRows: "unset",
      gridTemplateColumns: "repeat(3, 1fr)",
      gridGap: `calc(${jssVariables.normal_gap} / 2)`,
      ..._.get(props, "customStyles.packageSearchForm..smallscreen", {}),
    }),
  },
});
export const PackageSearchForm = ({ onChange, customStyles }) => {
  const classes = styles({
    customStyles,
  });

  const [formikValues, setFormikValues] = useState({});

  const { packagesMetadata, search_form } = useSelector((state) => {
    return {
      packagesMetadata: _.get(state.WebsiteMetadata, "packagesMetadata", []),
      search_form: state.TourSearchForm,
    };
  });

  function onChangeServices(value) {
    onChange("services", value);
  }
  function onChangeDurations(value) {
    onChange("durations", value);
  }

  useEffect(() => {
    const keys = Object.keys(formikValues);
    keys.forEach((key) => {
      if (key === "destination_code") {
        onChange("destination_code", formikValues[key]);
      }
    });
  }, [formikValues]);

  return (
    <Formik
      initialValues={{
        destinationObj: {
          destination_code: _.get(search_form, "destination_code", []),
          destination_meta: _.get(search_form, "destination_meta", []),
        },
      }}>
      {({ values }) => {
        setFormikValues(values);
        return (
          <Form className={classes.packageSearchForm}>
            <DestinationsPicker
              types={["DEST"]}
              product_type={"PKG"}
              customStyles={_.get(customStyles, "DestinationsPicker", {})}
              value={_.get(search_form, "destination_code", [])}
              onChange={onChange}
            />
            <ServicesPicker
              customStyles={_.get(customStyles, "ServicesPicker", {})}
              ghost={!_.get(packagesMetadata, "services", []).length}
              services={_.get(packagesMetadata, "services", [])}
              value={_.get(search_form, "services", [])}
              onChange={onChangeServices}
            />
            <DurationsPicker
              customStyles={customStyles?.DurationsPicker ?? {}}
              ghost={!(packagesMetadata?.durations ?? []).length}
              durations={packagesMetadata?.durations ?? []}
              value={search_form?.durations ?? []}
              onChange={onChangeDurations}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
PackageSearchForm.defaultProps = {
  destinationPlaceholder: "",
  search_form: {},
  onChange: PropTypes.func.isRequired,
  customStyles: PropTypes.object.isRequired,
  ghost: PropTypes.bool.isRequired,
  autocomplete: PropTypes.bool.isRequired,
  destinations: PropTypes.array.isRequired,
  onChangeServices: PropTypes.func.isRequired,
  packagesMetadata: PropTypes.object.isRequired,
};
PackageSearchForm.propTypes = {
  destinationPlaceholder: PropTypes.string.isRequired,
  search_form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  customStyles: PropTypes.object.isRequired,
  ghost: PropTypes.bool.isRequired,
  autocomplete: PropTypes.bool.isRequired,
  destinations: PropTypes.array.isRequired,
  onChangeServices: PropTypes.func.isRequired,
  packagesMetadata: PropTypes.object.isRequired,
};
